var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature3Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4878 21.2687H55.5121M11.9468 12.5618L16.9314 21.1952M23.6541 12.5618L28.6386 21.1952M35.3614 12.5618L40.3458 21.1952M47.0686 12.5618L52.0531 21.1952M11.9024 12.4883H52.0976C54.2439 12.4883 56 14.2444 56 16.3907V47.6101C56 49.7564 54.2439 51.5125 52.0976 51.5125H11.9024C9.75609 51.5125 8 49.7564 8 47.6101V16.3907C8 14.2444 9.75609 12.4883 11.9024 12.4883Z",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5293 38.0728L28.3639 43.9359C27.4424 44.4691 26.2627 44.155 25.729 43.2344C25.5588 42.9408 25.4645 42.609 25.4648 42.2691V30.5168C25.4648 29.4504 26.3302 28.5859 27.3976 28.5859C27.7982 28.5859 28.1704 28.7077 28.479 28.9162L38.5519 34.726C39.4734 35.2592 39.7877 36.4377 39.2541 37.3582C39.0813 37.6573 38.8308 37.9042 38.5293 38.0728Z",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3Svg);
export default __webpack_public_path__ + "static/media/feature3SVG.57304029b43d0d8a526f5eea6ec22d2e.svg";
export { ForwardRef as ReactComponent };